import MenuToggle from "components/MenuToggle";
import {getIsNative} from "modules/selectors/entryPoint";
import {useIsMobile} from "modules/utils/hooks";
import React, {Fragment} from "react";
import {useSelector} from "react-redux";
import styled from "@emotion/styled";
import {NavLink, useLocation} from "react-router-dom";
import {Exist} from "components/Exist";
import {IconButton} from "@mui/material";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import {useNavigate} from "react-router";
import {useTranslation} from "react-i18next";

const Position = styled.div`
	display: flex;
	justify-content: center;
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 0;
	@media (max-width: 880px) {
		body[class*="fixed"] & {
			display: none;
		}
	}
`;

const Wrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 10px 30px 30px;
	height: 79px;
	width: 100%;
	pointer-events: none;
`;

const Placeholder = styled.div`
	margin-right: auto;
`;

const MLBPlayHeader = styled.div`
	height: 50px;
	background: #090b0f;
	//z-index: 999;
	//position: relative;
	//display: flex;
	//justify-content: space-between;
	//align-items: center;
	//flex-shrink: 0;
	img {
		max-height: 30px;
	}

	div {
		width: 100%;
		height: 50px;
		flex: 1 1 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}
`;

const Nav = styled.nav`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;
	flex: 1 1 100%;
	a {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 120px;
		min-width: 120px;
		font-weight: 700;
		font-size: 14px;
		line-height: 14px;
		text-align: center;
		color: #848990;
		height: 100%;

		&.active {
			color: #fff;
			border-bottom: 4px solid #2687ff;
		}
	}
`;

const MobileNav = styled(Nav)`
	height: 50px;
	max-height: 50px;
	a {
		flex: 1;
		font-weight: 600;
		font-size: 16px;
		padding-bottom: 10px;
		border-bottom: 4px solid transparent;
		align-self: flex-end;
		&.active {
			color: #fff;
			border-bottom: 4px solid #2687ff;
		}
	}
`;

const MLBPlayHeaderMobile = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 80px;
`;

const WebHeaderMobile = styled(MLBPlayHeaderMobile)`
	height: 100px;
	display: flex;
	flex-flow: column;
	width: 100%;
	justify-content: flex-end;

	& > button {
		color: #fff;
		margin-right: auto;
		margin-left: 20px;
	}
`;

const Logo = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	font-style: normal;
	font-weight: 700;
	font-size: 18px;
	line-height: 18px;
	text-align: center;
	color: #ffffff;
	flex: 1 1 100%;
	a {
		display: block;
		position: absolute;
		left: 16px;
		top: 50%;
		transform: translateY(-50%);
	}
`;

// const Navigation = () => (
// 	<Nav>
// 		<a href={`${CONSTANTS.MAIN_PLAY_HREF}/games`} className="active">
// 			Games
// 		</a>
// 		<a href={`${CONSTANTS.MAIN_PLAY_HREF}/feed`}>Feed</a>
// 		<a href={`${CONSTANTS.MAIN_PLAY_HREF}/profile`}>Profile</a>
// 	</Nav>
// );

const ladderManuPaths = ["leaderboard", "groups"];

const LadderMenu = () => {
	const i18n = useTranslation();
	return (
		<MobileNav>
			<NavLink
				to={"/leaderboard"}
				className={({isActive}) => (isActive ? "active" : undefined)}
			>
				{i18n.t("header.nav.leaderboard", "Leaderboard")}
			</NavLink>
			<NavLink to={"/groups"} className={({isActive}) => (isActive ? "active" : undefined)}>
				{i18n.t("header.nav.groups", "Groups")}
			</NavLink>
		</MobileNav>
	);
};

const Header: React.FC = () => {
	const isMobile = useIsMobile();
	const isNative = useSelector(getIsNative);
	const navigate = useNavigate();
	const location = useLocation();
	const isLadderMenu = ladderManuPaths.some((path) => location.pathname.includes(path));

	return (
		<Fragment>
			{isNative ? (
				<Exist when={isLadderMenu}>
					<WebHeaderMobile>
						<IconButton onClick={() => navigate("../")}>
							<ArrowBackIosNewRoundedIcon />
						</IconButton>
						<LadderMenu />
					</WebHeaderMobile>
				</Exist>
			) : (
				<Fragment>
					{isMobile ? (
						<MLBPlayHeaderMobile>
							<Logo>
								{/*<a href={`${CONSTANTS.MAIN_PLAY_HREF}/games`}>*/}
								{/*	<img src={MLBPlayLogoSmall} alt="MLB Games" />*/}
								{/*</a>*/}
								{/*<span>MLB Play</span>*/}
							</Logo>
							{/*<Exist when={!isLadderMenu}>*/}
							{/*	<Navigation />*/}
							{/*</Exist>*/}
							<Exist when={isLadderMenu}>
								<LadderMenu />
							</Exist>
						</MLBPlayHeaderMobile>
					) : (
						<MLBPlayHeader>
							{/*<Navigation />*/}
							{/*<div>*/}
							{/*	<a href={`${CONSTANTS.MAIN_PLAY_HREF}/games`}>*/}
							{/*		<img src={MLBPlayLogo} alt="MLB Games" />*/}
							{/*	</a>*/}
							{/*</div>*/}
							{/*<div />*/}
						</MLBPlayHeader>
					)}
				</Fragment>
			)}

			<Position>
				<Wrapper>
					<Placeholder />
					<MenuToggle />
				</Wrapper>
			</Position>
		</Fragment>
	);
};

export default Header;
